import * as React from 'react';
import * as S from './styles';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { IOverallProps } from './types';
import Plataform from './Platform';
import { ArrowDownIcon } from 'common/icons/arrowdownIcon';
import { ProviderRating } from '../../state/types';
import { getIsSelected } from '../../state/utils';
import EditIcon from 'common/icons/editIcon';
import { Context } from '../../context';
import { createRGBA } from '../../state/utils';
import EmptyMessage from '../EmptyMessage';
import { EmptyMessageContainer } from '../EmptyMessage/styles';

const ReviewsByPlatformWidget: React.FC<IOverallProps> = (props) => {
    const [seeMore, setSeeMore] = React.useState<boolean>(false);
    const [hideSeeMore, setHideSeeMore] = React.useState<boolean>(false);
    const componentRef = React.useRef(null);
    const context = React.useContext(Context);

    const {
        providersRating,
        widgets
    } = useSelector((rootState: RootState) => {
        return {
            selectedDealerId: rootState.dealers.dealer.selectedDealer?.id,
            providersRating: rootState.reviews.providersRating,
            widgets: rootState.reviews.widgets,
        }
    }, shallowEqual);

    const handleEditProviders =  (event: any) => {
        var container = document.getElementById('container');
        if (container) {
            var rect = container.getBoundingClientRect();
            var x = event.clientX + container.scrollLeft - rect.left - 581;
            var y = event.clientY + container.scrollTop - rect.top -150;
            props.handleEditProviders({show: true, posX: x , posY: y, widget: 'providersRating'})
        }
    }

    const getErrorMessage = (providers: ProviderRating[]|undefined) => {
        if (props.selectedTab==="entire") {
            if ((providers!==undefined && providers.length<3 && props.totalSelected===undefined) || (props.totalSelected!==undefined && props.totalSelected<3))
                return 'NOTE: If you select less than 3 providers, this section will not show';
            else if (providers) {
                let selectedWithReviews : number = providers.filter((provider: ProviderRating) => provider.averageStartRating===0).length;
                return selectedWithReviews>0 ? 'You have selected one or more providers that don’t have any reviews currently. They will not be displayed when rendered on the website.' : '';
            }
        }
    }

    React.useEffect(() => {
        setSeeMore(false);
        setHideSeeMore(false);
    }, [props.selectedTab]);

    React.useEffect(() => {
        if (componentRef.current && !seeMore) setHideSeeMore(!checkOverflow(componentRef.current));
    }, [props.widgetsConfig, providersRating?.providersRating, props.selectedTab, seeMore]);

    const checkOverflow = (el) => el.offsetHeight < el.scrollHeight;
    const providersToShow = providersRating?.providersRating?.filter((provider: ProviderRating) => getIsSelected(provider, props.selectedTab, widgets, 'providersRating'));
    const starColor= context.editingStatus.star?.id === "providersRating" ? createRGBA(context.editingStatus.star.color ?? "#FFD84D", context.editingStatus.star.opacity) : createRGBA(props.widgetsConfig.providersRating.starColor ?? "#FFD84D", props.widgetsConfig.providersRating.starOpacity);
    const linkColor= context.editingStatus.link?.id === "providersRating" ? createRGBA(context.editingStatus.link.color ?? "#4da0ff", context.editingStatus.link.opacity) : createRGBA(props.widgetsConfig.providersRating.linkColor ?? "#4da0ff", props.widgetsConfig.providersRating.linkOpacity);
    const bodyColor = context.editingStatus.bodyText?.id === "providersRating" ? context.editingStatus.bodyText.color : props.widgetsConfig.providersRating.bodyTextColor ?? "#000000";

    const hasProviders = providersToShow && providersToShow.length > 0;

    const renderEditIcon = () => {
        if (props.selectedTab === "individual") {
            return (
                <S.EditIconContainer onClick={(e) => handleEditProviders(e)}>
                    <EditIcon />
                </S.EditIconContainer>
            );
        }
    }

    return (
    <S.Root>
        <S.Warning>{getErrorMessage(providersToShow)}</S.Warning>
        <S.PlataformsContainer ref={componentRef} seeMore={seeMore}>
            {providersToShow && providersToShow.length>0 && providersToShow?.map((provider: ProviderRating) => 
            <Plataform provider={provider} starColor={starColor} linkColor={linkColor} bodyColor={bodyColor} />
            )}
            {
                !hasProviders && 
                <EmptyMessageContainer>
                    <EmptyMessage
                        message="Select platforms & display their reviews"
                        containerStyle={{height: "90px"}}
                        style={{padding: "0px 75px"}}
                    />
                    {renderEditIcon()}
                </EmptyMessageContainer>
            }
            
            {hasProviders && renderEditIcon()}
        </S.PlataformsContainer>
        {(!hideSeeMore && hasProviders) &&
        <S.SeeMoreContainer>
            <S.Label  onClick={() => setSeeMore(!seeMore)}>{seeMore ? 'See less' : 'See more'}</S.Label>
            <S.RotateIcon rotationValue={!seeMore ? `rotate(0deg)` : `rotate(180deg)`}  onClick={() => setSeeMore(!seeMore)}>
                <ArrowDownIcon/>
            </S.RotateIcon>
        </S.SeeMoreContainer>}
    </S.Root>
    )
}

export default ReviewsByPlatformWidget;
